// **************** ROUTE CONSTANT START **************************
// General Page Section
export const DASHBOARD = '/'
export const BOARDS = '/boards'
export const POS = '/pos'
export const RAFFLES = '/raffles'
export const PRODUCTS = '/products'
export const CATEGORY = '/category'
export const LOGIN = '/login'
export const LOGOUT = '/logout'
export const ORDERS = '/orders'
export const CUSTOMERS = '/customers'
export const COUPONS = '/coupons'
export const SETTINGS = '/settings'
export const STAFF_MEMBERS = '/staff-members'
export const SITE_SETTINGS = '/site-settings'
export const RAFFLE_GAME = '/lanzar-sorteo'
export const EXPOSITORES = '/expositores'
export const CREDENCIALES = '/expositores/:id/credenciales'
export const EXPOSITORESCREDENCIALES = '/credenciales'
// **************** ROUTE CONSTANT END **************************

export const CURRENCY = '$'
